import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { OutstandingInvoiceLogItem } from 'src/types/edi';
import axiosInstance from 'src/utils/axios';

export interface UseOutstandingInvoiceLogsQueryParams {
  enabled?: boolean;
}

const useOutstandingInvoiceLogsQuery = ({
  enabled = true,
}: UseOutstandingInvoiceLogsQueryParams = {}) => {
  const [lastRequestedAt, setLastRequestedAt] = useState(0);

  const query = useQuery<OutstandingInvoiceLogItem[]>({
    queryKey: queryKeys.ediAdmin.outstandingInvoiceLogs(),
    enabled,
    queryFn: async () => {
      setLastRequestedAt(Date.now());
      const res = await axiosInstance.get<OutstandingInvoiceLogItem[]>(
        api.getOutstandingInvoiceLogs
      );
      return res.data ?? [];
    },
  });

  return {
    ...query,
    lastRequestedAt,
  };
};

export default useOutstandingInvoiceLogsQuery;
